/**
 * Public URL for `GET /api/v1/initiatives/{id}/image/{fileName}` (image bytes).
 * Must stay in sync with `Fetch` axios `baseURL` (`VITE_BACKEND_URL` + `/api/v1`).
 */
export function initiativeImageBinaryUrl(initiativeId: string, imageFileName: string): string {
  const origin = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/+$/, '');
  const prefix = origin ? `${origin}/api/v1` : '/api/v1';
  const segment = encodeURIComponent(imageFileName);
  return `${prefix}/initiatives/${initiativeId}/image/${segment}`;
}

/** `GET .../initiatives/{id}/document/{fileName}` — document bytes. */
export function initiativeDocumentBinaryUrl(
  initiativeId: string,
  documentFileName: string
): string {
  const origin = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/+$/, '');
  const prefix = origin ? `${origin}/api/v1` : '/api/v1';
  const segment = encodeURIComponent(documentFileName);
  return `${prefix}/initiatives/${initiativeId}/document/${segment}`;
}

export function supportMaterialImageBinaryUrl(imageFileName: string): string {
  const origin = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/+$/, '');
  const prefix = origin ? `${origin}/api/v1` : '/api/v1';
  const segment = encodeURIComponent(imageFileName);
  return `${prefix}/support-materials/images/${segment}`;
}

/** `GET .../initiatives/{id}/document/{fileName}` — document bytes. */
export function supportMaterialDocumentBinaryUrl(documentFileName: string): string {
  const origin = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/+$/, '');
  const prefix = origin ? `${origin}/api/v1` : '/api/v1';
  const segment = encodeURIComponent(documentFileName);
  return `${prefix}/support-materials/documents/${segment}`;
}
